import { useEffect } from "react";
import { useState } from "react";
import styles from "./styles.module.css"

export default function InputCheckBox({ data, handleCategoryChange, allData }) {

    const [check, setCheck] = useState()


    useEffect(() => {
        let teste = allData.find((all) => {
            if (all.id === data.id) {
                return true
            }
        });
        if (teste) {
            setCheck(true)
        }

    }, [check]);


    function handleChecked() {
        if (check) {
            setCheck(false)
        } else {
            setCheck(true)
        }
    }


    return (
        <div className={styles.formFields__categoriesCheckbox}>
            <input
                checked={check}
                onClick={handleChecked}
                type="checkbox" value={data.name}
                onChange={(event) => { handleCategoryChange(event, data); }}
                name={data.name}
                id={data.id} />
            <span>{data.name}</span>
        </div>
    );
}